import useSWR from "swr";


export const useFetchTotalRestaurantSurveyResponse = (restaurantId?: string, queryParams?: URLSearchParams) => {
  const fetchKey = restaurantId
    ? `restaurant_staff/restaurants/${restaurantId}/restaurant-survey/responses/total/${queryParams?.toString() && `?${queryParams}`}`
    : null;
  const { data: totalRestaurantSurveyResponse, error, isLoading } = useSWR<number>(fetchKey)
  return { totalRestaurantSurveyResponse, isLoading, error };
};